import React from 'react';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
    labelTextStyles,
    valueTextStyles,
    descriptionPaperStyles
} from '../../../ExitRequestResponseUnified/ExitRequestResponseStyles';
import { UI_CONSTANTS } from './RequestDetailsTab.constants';

export const DescriptionField = ({ label, content, onExpand, iconLabel, theme }) => (
    <>
        <Box sx={styles.labelContainer}>
            <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                    ...labelTextStyles,
                    mb: 0.5,
                    fontSize: UI_CONSTANTS.FONT_SIZES.LABEL
                }}
            >
                {label}
            </Typography>
            <IconButton
                size="small"
                sx={styles.expandButton(theme)}
                onClick={onExpand}
                aria-label={iconLabel}
            >
                <InfoOutlinedIcon />
            </IconButton>
        </Box>
        <Paper
            variant="outlined"
            sx={{
                ...descriptionPaperStyles(theme),
                maxHeight: UI_CONSTANTS.MAX_DESCRIPTION_HEIGHT
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    ...valueTextStyles,
                    fontSize: UI_CONSTANTS.FONT_SIZES.LABEL
                }}
            >
                {content}
            </Typography>
        </Paper>
    </>
);

const styles = {
    labelContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    expandButton: (theme) => ({
        ml: 1,
        transform: 'scale(0.8)',
        bgcolor: 'rgba(255,255,255,0.7)',
        '&:hover': {
            bgcolor: 'rgba(255,255,255,0.9)',
            color: theme.palette.primary.main
        }
    })
};